import { addMoneys } from '@afterpay/utils/lib/money'
import { useItemsDataVault } from '../../../../state'
import { EnrichedItem, money } from '../../../../model'
import { ItemType, OfferDetailItem, type CheckoutPaymentSchedule } from '@afterpaytouch/portal-api'
import { PaymentType, type Money } from '@afterpay/types'

interface DetailedItemViewModel {
  primaryData?: EnrichedItem
  childData?: EnrichedItem
  primaryAmountPlusChildAmount?: Money
  schedules: CheckoutPaymentSchedule[]
  isPayInFull: boolean
  hasInterestAmount: boolean
  hasDownpayment: boolean
  isShippingItem: boolean
  subItems: OfferDetailItem[]
}

export const useDetailedItemViewModel = (id: string): DetailedItemViewModel => {
  const data = useItemsDataVault()
  const primaryData = data[id]
  const childData = typeof primaryData?.childId === 'string' ? data[primaryData.childId] : undefined

  const primaryAmountPlusChildAmount =
    childData && primaryData?.price ? money(addMoneys({ moneys: [primaryData.price, childData.price] }), primaryData.price.currency) : undefined

  const schedules = Array.isArray(primaryData?.paymentSchedules) ? primaryData.paymentSchedules : []
  const hasInterestAmount = Number(primaryData?.interestAmount?.amount) > 0
  const hasDownpayment = Number(primaryData?.downPaymentAmount?.amount) > 0
  const isPayInFull = schedules.length === 1 && primaryData.paymentType === PaymentType.PBI
  const isShippingItem = primaryData?.type === ItemType.SHIPPING
  const subItems = primaryData?.items ?? []

  return {
    primaryData,
    childData,
    primaryAmountPlusChildAmount,
    schedules,
    isPayInFull,
    hasInterestAmount,
    hasDownpayment,
    isShippingItem,
    subItems,
  }
}
